import { put, call, takeLatest, all } from 'redux-saga/effects';
import NinLogTypes from './types';
import request from 'utils/request';
import { DEFAULT_ERROR_MESSAGE } from 'utils/constants';
import urls from 'utils/config';
import { fetchNinLogSuccess, fetchNinLogFailure } from './actions';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { API_BASE_URL } = urls || {};

function* fetchNinLog({ data }) {
  const { size = 10, page = 0, q, operation, found } = data || {};
  const params = new URLSearchParams();
  params.set('page', String(page));
  params.set('size', String(size));
  if (q) params.set('q', q);
  if (operation) params.set('operation', operation);
  if (found === true || found === false) params.set('found', String(found));

  const url = `${API_BASE_URL}/nin-verification-logs?${params.toString()}`;

  const response = yield request({
    method: 'get',
    url,
  });

  if (response.success) {
    yield put(fetchNinLogSuccess(response.raw));
  } else {
    yield put(fetchNinLogFailure(DEFAULT_ERROR_MESSAGE));
    networkErrorHandler(response?.statusCode, response?.message);
  }
}

function* onFetchNinLog() {
  yield takeLatest(NinLogTypes.FETCH_NIN_LOG_START, fetchNinLog);
}

export function* ninLogSagas() {
  yield all([call(onFetchNinLog)]);
}
